import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ServiceIDByLabel from "../../../services/ServiceIDByLabel";
import checkIfEnable from "../../../utils/checkIfEnable";
import { TopNavMenu } from "../../../utils/configurationProvider.js";
import TEXT from "../../../utils/globalText";
import MenuItemCard from "../MenuItemCard";
import "./index.css";

const NavbarMenuPopover = ({ data, open, type, handleMenuItemClick }) => {
  const elementRef = useRef(null);
  const contentRef = useRef(null);
  const lastTypeRef = useRef(type);
  const lastDataRef = useRef(data);

  const [showDisabledText, setShowDisabledText] = useState(false);
  const services_list = useSelector((state) => state.refreshToken.services);

  const stableType = open ? type : lastTypeRef.current;
  const stableData = open ? data : lastDataRef.current;

  // useLayoutEffect
  useLayoutEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const animateHeight = () => {
      if (!open) {
        const currentHeight = el.scrollHeight;
        el.style.height = `${currentHeight}px`;
        el.getBoundingClientRect();
        el.style.height = "var(--height-base)";
        return;
      }

      const startHeight = el.offsetHeight;
      el.style.height = "auto";
      const endHeight = el.scrollHeight;

      el.style.height = `${startHeight}px`;
      el.getBoundingClientRect();
      el.style.height = `${endHeight}px`;
    };

    animateHeight();

    const handleResize = () => {
      if (!open) return;
      el.style.height = "auto";
      const newHeight = el.scrollHeight;
      el.style.height = `${newHeight}px`;
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [open, stableType, stableData]);

  useEffect(() => {
    if (open) {
      const timeout = setTimeout(() => setShowDisabledText(true), 300);
      return () => clearTimeout(timeout);
    } else {
      setShowDisabledText(false);
    }
  }, [open]);

  useEffect(() => {
    if (open) {
      lastTypeRef.current = type;
      lastDataRef.current = data;
    }
  }, [type, data, open]);

  useEffect(() => {
    if (open) {
      lastTypeRef.current = type;
    }
  }, [type, open]);

  let sectionTitles = data.map((section, index) => (
    <div
      key={index}
      className="section-title"
    >
      {section.title}
    </div>
  ));
  if (type === "accounts") {
    sectionTitles.push(
      <div
        style={{
          visibility: "hidden",
          fontFamily: "monospace",
        }}
        className="section-title"
        key="42"
      >
        {" ".padStart(15, " ")}
      </div>,
    );
  }

  return (
    <div
      ref={elementRef}
      className={`popover-main ${open ? "open" : ""}`}
    >
      <div
        ref={contentRef}
        className={`relative max-w-tab-width-normal mx-auto overflow-hidden Qsmd:px-padding-md lg:px-padding-base content-section`}
      >
        {stableType === "transactions" && (
          <div className="flex flex-col gap-y-gap-sm my-margin-sm">
            <div className="flex flex-row gap-x-gap-md">
              {stableData.map((section, index) => (
                <div
                  key={index}
                  className="flex flex-col gap-y-gap-md flex-grow "
                >
                  <p className="text-font-md text-primary-bg font-semibold uppercase">
                    {section?.title}
                  </p>

                  <div
                    className={`grid ${section.menuItems.length === TopNavMenu.menuItems ? "grid-cols-2 lg:grid-cols-3" : "grid-cols-3"} gap-gap-md`}
                  >
                    {section?.menuItems?.map((item, id) => (
                      <div
                        key={id}
                        onClick={() => {
                          if (
                            checkIfEnable(
                              ServiceIDByLabel,
                              item.label,
                              services_list,
                            )
                          )
                            handleMenuItemClick(item.route);
                        }}
                        className={`w-width-full ${
                          checkIfEnable(
                            ServiceIDByLabel,
                            item.label,
                            services_list,
                          )
                            ? "cursor-pointer opacity-base-opacity"
                            : "cursor-not-allowed opacity-light-opacity"
                        }`}
                      >
                        <MenuItemCard
                          icon={item?.icon}
                          label={item?.label}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <div>
              <p className="text-font-xxs text-text-disabled font-normal text-right">
                {TEXT?.NAVBAR_WARNING}
              </p>
            </div>
          </div>
        )}

        {stableType === "accounts" && (
          <div className="flex flex-col gap-y-gap-sm my-margin-sm">
            <div className="flex flex-col Qlg:flex-row gap-gap-md">
              {stableData.map((section, index) => (
                <div
                  key={index}
                  className="flex flex-col gap-y-gap-md flex-grow w-width-full Qlg:w-width-md"
                >
                  <p className="text-font-md text-primary-bg font-semibold uppercase">
                    {section?.title}
                  </p>

                  <div
                    className={`grid ${section.menuItems.length === TopNavMenu.menuItems ? "grid-cols-2 lg:grid-cols-3" : "grid-cols-3"} gap-gap-md`}
                  >
                    {section?.menuItems?.map((item, id) => (
                      <div
                        key={id}
                        onClick={() => {
                          if (
                            checkIfEnable(
                              ServiceIDByLabel,
                              item.label,
                              services_list,
                            )
                          )
                            handleMenuItemClick(item.route);
                        }}
                        className={`w-width-full ${
                          checkIfEnable(
                            ServiceIDByLabel,
                            item.label,
                            services_list,
                          )
                            ? "cursor-pointer opacity-base-opacity"
                            : "cursor-not-allowed opacity-light-opacity"
                        }`}
                      >
                        <MenuItemCard
                          icon={item?.icon}
                          label={item?.label}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <p className="text-font-xxs text-text-disabled font-normal text-right">
              {TEXT?.NAVBAR_WARNING}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NavbarMenuPopover;
